export const horizontalPadding = "30px";
export const verticalPadding = "16px";
export const perelynRed = "#FF5950";
export const tableHeaderBackground = "#E8E8E8";
export const tableBorder = "1px solid black";
